module.exports = __webpack_public_path__ + "img/badge-vacuum-cleaner.ae4b72ad.svg";